import { DropdownMenu, DropdownMenuItem } from "../CustomHeader/HeaderStyles";
import Text from "../Common/Text";

const CustomActionMenu = ({
  handleMenuClick,
  options,
  empresa,
  record,
  colors,
  testid,
}) => {
  return (
    <DropdownMenu
      isOpen={true}
      style={{
        zIndex: 10000,
        position: "absolute",
        transform: "translateX(-50%)",
        left: "50%",
      }}
      data-testid={testid}
    >
      {options.map((option) => (
        <DropdownMenuItem
          key={option.value}
          onClick={() => handleMenuClick(option, record)}
          backGroundHover={empresa?.COLOR_PRINCIPAL}
          data-testid={`custom-action-menu-item-${option.value}`}
        >
          <Text
            size="15px"
            color={colors.primaryPrimera}
            hoverColor={colors.white}
          >
            {option.label}
          </Text>
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default CustomActionMenu;
